import 'dayjs/locale/nl';
import 'dayjs/locale/fr';
import 'dayjs/locale/en';
import 'dayjs/locale/de';

import DayJS, { ConfigType } from 'dayjs';

export function formatDateTimeString(date: ConfigType, locale: string = 'nl') {
  return (
    DayJS(date)
      // @ts-ignore
      .locale(locale)
      .format('DD MMMM YYYY, HH:mm')
  );
}
